import { defineAction, object } from '~/prix'
import communityFetchAction from './geoCommunityFetch.action.json' assert { type: 'json' }
// import { communityObject } from '../geoCommunityObject'
// import { z } from 'zod'

const communityFetchDefinition = defineAction({
  ...communityFetchAction,

  // input: z.object({ id: z.string() }),
  // output: communityObject,

  input: object<any>({}),
  output: object<any>({}),
})

export default communityFetchDefinition
